import { render, staticRenderFns } from "./CompanyCard.vue?vue&type=template&id=1054d96a&scoped=true"
import script from "./CompanyCard.vue?vue&type=script&lang=ts"
export * from "./CompanyCard.vue?vue&type=script&lang=ts"
import style0 from "./CompanyCard.vue?vue&type=style&index=0&id=1054d96a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1054d96a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1054d96a')) {
      api.createRecord('1054d96a', component.options)
    } else {
      api.reload('1054d96a', component.options)
    }
    module.hot.accept("./CompanyCard.vue?vue&type=template&id=1054d96a&scoped=true", function () {
      api.rerender('1054d96a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/CompanyCard.vue"
export default component.exports